import Vue from 'vue'
import Router from 'vue-router'
import Insideburgundy from '@/components/Insideburgundy'
import HelloWorld from '@/components/HelloWorld'
import JASPER from '@/components/JASPER'
import Burgundy from '@/components/Burgundy'
import Theactivity from '@/components/Theactivity'
import Eventdetails from '@/components/Eventdetails'
import Appraisal from '@/components/Appraisal'
import Qualification from '@/components/Qualification'
import Latest from '@/components/Latest'
import Consultation from '@/components/Consultation'
import Subscribe from '@/components/Subscribe'
import Login from '@/components/Login'
import Register from '@/components/Register'
import Faqs from '@/components/Faqs'
import Report from '@/components/Report'
import Myaccount from '@/components/Myaccount'
import Myinformation from '@/components/Myinformation'
import History from '@/components/History'
import Periodical from '@/components/Periodical'
import Latestinformation from '@/components/Latestinformation'
import Tastingnotes from '@/components/Tastingnotes'
import Introductionpage from '@/components/Introductionpage'
import Appraisalreport from '@/components/Appraisalreport'
import Fivestars from '@/components/Fivestars'
import Forgetpassword from '@/components/Forgetpassword'
import Myprofile from '@/components/Myprofile'
import Mybookmarks from '@/components/Mybookmarks'
import Myvisit from '@/components/Myvisit'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/Myvisit',
      name: 'Myvisit',
      component:Myvisit
    },
    {
      path: '/Mybookmarks',
      name: 'Mybookmarks',
      component:Mybookmarks
    },
    {
      path: '/Myprofile',
      name: 'Myprofile',
      component:Myprofile
    },
    {
      path: '/Forgetpassword',
      meta: 'register',
      name: 'Forgetpassword',
      component:Forgetpassword
    },
    {
      path: '/Fivestars',
      meta: 'register',
      name: 'Fivestars',
      component:Fivestars
    },
    {
      path: '/Appraisalreport',
      meta: 'register',
      name: 'Appraisalreport',
      component:Appraisalreport
    },
    {
      path: '/Introductionpage',
      meta:'register',
      name: 'Introductionpage',
      component:Introductionpage
    },
    {
      path: '/tastingnotes',
      meta:'register',
      name: 'Tastingnotes',
      component:Tastingnotes
    },
    {
      path: '/latestinformation',
      meta:'register',
      name: 'Latestinformation',
      component:Latestinformation
    },
    {
      path: '/periodical',
      meta:'register',
      name: 'Periodical',
      component:Periodical
    },
    {
      path: '/history',
      name: 'History',
      component:History
    },
    {
      path: '/myinformation',
      name: 'Myinformation',
      component: Myinformation
    },
    {
      path: '/myaccount',
      name: 'Myaccount',
      component: Myaccount
    },
    {
      path: '/insideburgundy',
      meta:'register',
      name: 'Insideburgundy',
      // eslint-disable-next-line comma-dangle
      component: Insideburgundy,
    },
    {
      path: '/report',
      meta:'register',
      name: 'Report',
      component: Report
    },
    {
      path: '/faqs',
      name: 'Faqs',
      component: Faqs
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/subscribe',
      // meta:'register',
      name: 'Subscribe',
      // eslint-disable-next-line no-undef
      component: Subscribe
    },
    {
      path: '/consultation',
      meta:'register',
      name: 'Consultation',
      component: Consultation

    },
    {
      path: '/latest',
      meta:'register',
      name: 'Latest',
      component: Latest
    },
    {
      path: '/qualification',
      meta:'register',
      name: 'Qualification',
      component: Qualification
    },
    {
      path: '/jasper',
      meta:'register',
      name: 'JASPER',
      component: JASPER
    },
    {
      path: '/theactivity',
      meta:'register',
      name: 'Theactivity',
      component: Theactivity
    },
    {
      path: '/appraisal',
      meta:'register',
      name: 'Appraisal',
      component: Appraisal
    },
    {
      path: '/eventdetails',
      name: 'Eventdetails',
      component: Eventdetails
    },
    {
      path: '/burgundy',
      meta:'register',
      name: 'Burgundy',
      component: Burgundy
    },
    {
      path:'/',
      redirect:'/home'
    },
    {
      path: '/home',
      meta:'register',
      name: 'HelloWorld',
      component: HelloWorld
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js